export const fixedHeader = () => {
  const header = document.querySelector(".header");
  const menuBtn = document.querySelector(".js-menu-btn");
  if (!header) return;

  // トップページかどうかを判定
  const isTopPage = document.body.classList.contains("home") || document.body.classList.contains("front-page");

  // PC/SP判定（max-width: 767px以下をSPとする）
  const mediaQuery = window.matchMedia("(max-width: 767px)");
  const isMobile = () => mediaQuery.matches;

  // メニューの表示状態を制御する関数
  const updateMenuState = () => {
    if (isTopPage) {
      if (isMobile()) {
        // TOP + SP: ハンバーガーボタンのみ、メニューは非表示
        header.classList.remove("is-open");
      } else {
        // TOP + PC: メニューは開いた状態
        header.classList.add("is-open");
      }
    } else {
      if (isMobile()) {
        // TOP以外 + SP: ハンバーガーボタンのみ、メニューは非表示
        header.classList.remove("is-open");
      } else {
        // TOP以外 + PC: 初期は非表示（ホバーで開く）
        header.classList.remove("is-open");
      }
    }
  };

  // ハンバーガーボタンのクリックイベント（SP用）
  const hamburgerMenu = document.querySelector(".js-hamburger-menu");

  if (menuBtn && hamburgerMenu) {
    menuBtn.addEventListener("click", () => {
      if (isMobile()) {
        hamburgerMenu.classList.toggle("is-active");
        document.body.classList.toggle("is-hamburger-menu-open");
      }
    });

    // ハンバーガーメニューの閉じるボタン
    const closeBtns = document.querySelectorAll(".js-hamburger-close");
    closeBtns.forEach((closeBtn) => {
      closeBtn.addEventListener("click", () => {
        hamburgerMenu.classList.remove("is-active");
        document.body.classList.remove("is-hamburger-menu-open");
      });
    });
  }

  // メディアクエリの変更を監視
  mediaQuery.addEventListener("change", updateMenuState);

  if (isTopPage) {
    const mvSection = document.querySelector(".mv");
    const aboutSection = document.querySelector(".about");

    if (!mvSection || !aboutSection) {
      header.classList.add("is-fixed");
      updateMenuState();
      return;
    }

    let mvHeight = mvSection.offsetHeight;

    const handleScroll = () => {
      const aboutTop = aboutSection.offsetTop;
      const scrollTop = window.pageYOffset;

      if (scrollTop >= aboutTop) {
        header.style.position = "fixed";
        header.style.top = "0px";
      } else {
        header.style.position = "absolute";
        header.style.top = mvHeight + "px";
      }
    };

    const updatePosition = () => {
      mvHeight = mvSection.offsetHeight;
      updateMenuState();
      handleScroll();
    };

    // 初期設定
    updatePosition();

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", updatePosition);
  } else {
    // 他のページ：最初から固定
    header.classList.add("is-fixed");
    updateMenuState();

    // TOP以外のPCではマウスホバーでメニュー開閉
    const setupHoverEvents = () => {
      if (!isMobile()) {
        header.addEventListener("mouseenter", handleMouseEnter);
        header.addEventListener("mouseleave", handleMouseLeave);
      } else {
        header.removeEventListener("mouseenter", handleMouseEnter);
        header.removeEventListener("mouseleave", handleMouseLeave);
      }
    };

    const handleMouseEnter = () => {
      if (!isMobile()) {
        header.classList.add("is-open");
      }
    };

    const handleMouseLeave = () => {
      if (!isMobile()) {
        header.classList.remove("is-open");
      }
    };

    setupHoverEvents();

    // メディアクエリ変更時にホバーイベントも再設定
    mediaQuery.addEventListener("change", setupHoverEvents);
  }
};
